// Зөвлөхөөс өгсөн ажил — тэмдэглэх мөр (нүүр ба уулзалтын хуудсанд)
import React from "react";
import { FiCheck } from "react-icons/fi";
import { dueLabel, dueSoon, overdue } from "./common";

export function Check({ checked, onChange, label, disabled }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`mt-0.5 h-5 w-5 shrink-0 rounded-md border-2 flex items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#5C1090] focus-visible:ring-offset-1 ${
        checked ? "bg-[#5C1090] border-[#5C1090] text-white" : "bg-white border-[#C9B6E4] hover:border-[#5C1090]"
      }`}
    >
      {checked && <FiCheck size={13} strokeWidth={3} />}
    </button>
  );
}

export default function ActionItem({ a, from, onToggle, busy }) {
  const done = !!a.doneAt;
  const late = !done && overdue(a.dueDate);
  const soon = !done && !late && dueSoon(a.dueDate);
  const badge = done
    ? "border-[#E5D8F5] text-[#6E5E8A] bg-white"
    : late
    ? "border-red-200 text-red-700 bg-red-50"
    : soon
    ? "border-[#F2CD30] text-[#1c1c1c] bg-[#F2CD30]"
    : "border-[#E5D8F5] text-[#5C1090] bg-white";
  return (
    <li className="flex gap-3 items-start px-4 py-3.5 border-b border-[#F3EEFF] last:border-b-0">
      <Check checked={done} disabled={busy} onChange={(v) => onToggle(a, v)} label={`${a.text} — ${done ? "дуусаагүй болгох" : "дууссан гэж тэмдэглэх"}`} />
      <span className="flex flex-col gap-1.5 min-w-0 flex-1">
        <span className={`text-sm font-semibold leading-snug break-words ${done ? "line-through text-[#6E5E8A]" : "text-gray-900"}`}>{a.text}</span>
        <span className="flex flex-wrap gap-x-2.5 gap-y-1 items-center text-xs text-[#6E5E8A]">
          <span className={`inline-flex items-center rounded-full border px-2 py-[1px] text-[11px] font-bold ${badge}`}>
            {done ? "Дууссан" : late ? `Хугацаа хэтэрсэн · ${dueLabel(a.dueDate).replace(" хүртэл", "")}` : dueLabel(a.dueDate)}
          </span>
          {from && <span className="truncate">{from}</span>}
        </span>
      </span>
    </li>
  );
}
